import { Trans } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

export function NotFound({ children }: { children?: ReactNode }) {
	return (
		<div className="space-y-2 p-2">
			<div className="text-gray-600 dark:text-gray-400">
				{children || (
					<p>
						<Trans>The page you are looking for does not exist.</Trans>
					</p>
				)}
			</div>
			<p className="flex items-center gap-2 flex-wrap">
				<button
					className="bg-emerald-500 text-white px-2 py-1 rounded-sm uppercase font-black text-sm"
					onClick={() => window.history.back()}
					type="button"
				>
					<Trans>Go back</Trans>
				</button>
				<Link
					className="bg-cyan-600 text-white px-2 py-1 rounded-sm uppercase font-black text-sm"
					to="/"
				>
					<Trans>Start Over</Trans>
				</Link>
			</p>
		</div>
	);
}
